import axios from 'axios';
import authHeader from "../auth-header";
import ConstApiUrls from "../const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL_UMKM

class FPermitService {
    getApiUrl() {
        return API_URL
    }
    getAllFPermit(){
        return axios.get(API_URL + `getAllFPermit`, { headers: authHeader() });
    }
    getAllFPermitPublic(){
        return axios.get(API_URL + `public/getAllFPermit`, { headers: authHeader() });
    }
    getAllFPermitByOrgLevel(){
        return axios.get(API_URL + `getAllFPermitByOrgLevel`, { headers: authHeader() });
    }

    getAllFPermitContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFPermit`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFPermitContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFPermitById(id){
        return axios.get(API_URL + `getFPermitById/${id}`, { headers: authHeader() });
    }
    updateFPermit(item){
        return axios.put(API_URL + `updateFPermit/${item.id}`, item, {headers: authHeader()})
    }
    createFPermit(item){
        return axios.post(API_URL + `createFPermit`, item, {headers: authHeader()})
    }
    deleteFPermit(id){
        return axios.delete(API_URL + `deleteFPermit/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFPermit(itemIds){
        return axios.delete(API_URL + `deleteAllFPermit`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FPermitService()